import { useTooltip } from "hooks/useTooltip";

export const BlobMonster = () => {
    const { tooltipRef } = useTooltip({ title: "Kato" });

    return (
        <div className="blob">
            <div className="monster" ref={tooltipRef}>
                <div className="eyebrow1"></div>
                <div className="eyebrow2"></div>
                <div className="eye"></div>
                <div className="eye"></div>
                <div className="mouth">
                    <div className="tooth1"></div>
                    <div className="tooth2"></div>
                </div>
                <div className="drop"></div>
            </div>
            <div className="shadow"></div>
        </div>
    );
};
